import type { SVGProps } from 'react'

interface PantanalBiomeIconProps extends SVGProps<SVGSVGElement> {}

export function PantanalBiomeIcon(props: PantanalBiomeIconProps) {
  return (
    <svg
      width={32}
      height={32}
      viewBox="0 0 32 32"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.799 0c.684.724 1.135 1.598 1.394 2.541.42 1.532.394 3.25.253 5-.284 3.502-.99 7.188-.166 9.475.773 2.147 2.012 3.422 3.387 4.049.59.27 1.213.419 1.843.458 1.505-4.392 1.184-9.997-1.292-13.786 3.278 3.255 4.827 8.17 3.826 13.322l-.595.238c.186-.056.37-.12.549-.192 2.833-1.139 5.152-4.47 4.187-9.357-.443-2.244-1.964-5.41-4.51-7.861C16.475 1.766 13.535.16 9.8 0zm19.256 12.385a5.338 5.338 0 01-.716 2.288c-.702 1.224-1.794 2.278-2.976 3.28-2.363 2.002-5.09 3.856-5.988 5.75-.851 1.794-.874 3.324-.42 4.54.195.521.485 1.001.857 1.415 3.641-1.807 6.898-5.46 7.717-9.314.005 4.025-2.077 8.009-5.874 10.588 2.428.982 5.85.34 8.254-3.222 1.113-1.65 2.14-4.542 2.09-7.617-.044-2.61-.832-5.347-2.944-7.708zM.245 17.343c-.644 3.096.047 5.86 1.321 8.142 1.502 2.689 3.844 4.682 5.637 5.557 3.87 1.888 7.155.74 8.765-1.318-4.584-.344-8.388-2.758-10.405-6.247 2.646 2.931 7.3 4.474 11.362 4.226a4.42 4.42 0 00.032-1.65c-.218-1.28-1.008-2.595-2.646-3.725-1.73-1.192-5.021-1.441-8.074-1.999-1.526-.279-3-.647-4.223-1.358a5.376 5.376 0 01-1.77-1.628z"
        fill="currentColor"
      />
    </svg>
  )
}
